module.exports = __webpack_public_path__ + "img/loading.7b330de3.gif";